import React from 'react';
import PropTypes from 'prop-types';
import './pageMode.css';

function PageMode(props) {
    return(
        <div className="pageMode__wrapper">
            {
                props.modesArray.map((modeName, index) => {
                    return(
                        <>
                            <input type="radio" name={ props.radioName || 'mode' } id={ modeName + 'RadioInput' }
                                value={ modeName.toUpperCase() } onChange={ props.onChangeHandler } checked={ modeName.toUpperCase() === props.checkedMode } />
                            <label className="pageMode__label" htmlFor={ modeName + 'RadioInput' }>{ modeName.toUpperCase() }</label>
                        </>
                    );
                })
            }
        </div>
    )
};

PageMode.propTypes = {
    modesArray: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    checkedMode: PropTypes.string.isRequired
};

export default PageMode;
